import BaseScene from "./BaseScene";

/*
HOWTO:

- Duplicate the scene with the name of your choice, and then replace 'REPLACEME' with the name of this scene.
- Each scene has access to all of the sponge tools via, this.sponge, as these are all typed classes itellisense will help you (try it!)
- You will need to add the scene to the index.ts to incorporate, as evals are not safe to use anymore.
-

*/

/**
 *
 * @category scenes
 * @export
 * @class REPLACEMEScene
 * @extends {BaseScene}
 */
export default class REPLACEMEScene extends BaseScene {


  // public somthing:Phaser.GameObjects.Text;

  constructor() {
    super({
      key: "REPLACEMEScene",
      active: false // false means this state isn't loaded on boot. true means its instantly activated.
    });
    console.log("REPLACEMEScene::constructor");
  }


  /**
   * preload any assets for this state
   *
   * 
   * @memberof REPLACEMEScene
   */
  preload(): void {
    console.log("REPLACEMEScene::preload");
    // load any used assets here, we are going to load per scene to improve memory performance.

    this.load.image("image","assets/images/somthing.png");

    super.preload();



  }

  /**
   * create any gameObjects that are required here.
   *
   * @memberof REPLACEMEScene
   */
  create(): void {
    console.log("REPLACEMEScene::create");
    // when scene is first loaded.
  }

  /**
   * Sleep is called when switching away from this state, use to pause this state
   * but with the potential to resume later, called when using state.run, state.switch, state.sleep
   *
   * @memberof REPLACEMEScene
   */
  sleep(): void {
    //hide any game objects when we transition out of this state.

  }

  /**
   * used for when a state is awoken from it's sleep state, called when using state.run, state.switch, state.sleep
   *
   * @memberof REPLACEMEScene
   */
  wake(): void {
    //wake / show game objects as we transition into this state.

  }

  /**
   * update is called on each frame, when the scene is in an active, non sleep state.
   *
   * @param {number} time time since app launch
   * @param {number} delta miliseconds since update.
   * @memberof REPLACEMEScene
   */
  update(time: number, delta: number): void {
    super.update(time, delta);
  }

  /**
   * destroy and remove this scene from memory.
   *
   * @memberof REPLACEMEScene
   */
  shutdown(): void {
    console.log("REPLACEMEScene::shutdown");

    // drop references to anything we have in create

    // try {
    // this.somthing.destroy();
    // this.somthing = undefined;
    // } catch (e) {
    //   console.warn("error trying to destroy somthing", e);
    // }

    // finally shutdown our state
    super.shutdown();

  }
}
